import { Center } from '@wegroup/design-system';
import React from 'react';

// Components
import { IconStatusCheck } from 'wg-fe-ui';

interface Props {
  size?: string;
}

const CheckMark: React.FC<React.PropsWithChildren<Props>> = ({
  size = '6',
  ...otherProps
}) => (
  <Center
    bg="primary.500"
    borderRadius="full"
    w={size}
    h={size}
    /* Fix icon offset */
    pr="2px"
    data-test-id="Common_CheckMark"
    sx={{
      '> svg': {
        width: '100%',
        height: '100%',
      },
    }}
    flexShrink={0}
    {...otherProps}
  >
    <IconStatusCheck color="#fff" />
  </Center>
);

export default CheckMark;
